module.exports = __webpack_public_path__ + "img/icon-pod-en.4667138b.svg";